<template>
    <a :href="url" class="link">
        <slot></slot>
    </a>
</template>

<script>
import SessionStorage from '../../../core/commons/SessionStorage';
import LocalStorage from 'Core/commons/LocalStorage';
import Feature from 'Services/Feature';

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        sub: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            meta: {},
        };
    },
    computed: {
        url: function () {
            const isCatalog = this.type.indexOf('catalog') === 0;
            const isPurchase = this.type.indexOf('pur') === 0;

            let url = '';
            if (isCatalog) {
                url = `/catalogue/${this.sub}`;
            } else {
                if (isPurchase) {
                    url = `/purchase/${this.type}`;
                } else {
                    url = `/sales/${this.type}`;
                    //security on feature flag 'numbering-draft'
                    if (this.sub && Feature.isEnabled('numbering-draft')) {
                        url += `/${this.sub}`;
                    }
                }
            }

            if (this.meta.hasOwnProperty('filters') === false) {
                return url;
            }
            const filters = $.param({ filter: this.meta.filters });
            return `${url}?${filters}`;
        },
    },
    created() {
        const location = window.location;
        const urlParams = new URLSearchParams(location.search);
        const contextId = urlParams.get('contextId');

        if (!contextId) {
            return false;
        }

        const splittedContext = contextId.split('_');
        const listingName = splittedContext[0];

        // Load & check overview context
        const storage = new SessionStorage('overview_context', contextId);
        if (storage.get() !== null) {
            this.meta = storage.get().meta;
        } else {
            // Load & check listing context
            const key =
                splittedContext.length === 3 ? listingName + '_' + splittedContext[2] : listingName;
            const context = new LocalStorage('listing_context', key).get();
            if (context) {
                this.meta = context.meta;
            }
        }
    },
};
</script>
